import { features } from '@root/swift.config';

export const getThumborUrl = () => {
    if (features?.thumbor?.enabled && features?.thumbor?.url) {
        return features.thumbor.url;
    }
    return '';
};
